import FormControlLabel from '@mui/material/FormControlLabel';
import { useTranslation } from 'react-i18next';
import { Grid, Switch } from '@mui/material';
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import IOSSwitch from '../IOSSwitch/IOSSwitch';
import { RoundedSkeleton } from './LoadingSkeleton';
import { CoachStatus, changeCoachStatus } from '../../redux/coach/coachSlice';
import createPermissionCheckers from '../../permissions-validation/createPermissionCheckers';
import { UserPermissionType } from '../../types/commonTypes';

interface IStatusSwitchProps {
  isActive: boolean;
  rowId: string;
}

const StatusSwitch = ({ isActive, rowId }: IStatusSwitchProps) => {
  const dispatch = useAppDispatch();
  const [value, setValue] = useState(isActive);
  const { changeCoachStatusLoading, statusChangedCoachId } = useAppSelector((state) => state.coach);
  const { t } = useTranslation();

  const permissionCheckers = createPermissionCheckers();
  const { checkPermissions } = permissionCheckers;

  const handleToggle = () => {
    const data = {
      coachId: rowId,
      status: !value ? CoachStatus.ENABLE : CoachStatus.DISABLE,
    };
    setValue(!value);
    dispatch(changeCoachStatus(data));
  };

  if (!rowId) return null;

  return changeCoachStatusLoading && statusChangedCoachId === rowId ? (
    <Grid gap={1} display="flex" flexDirection="row" alignItems="center">
      <RoundedSkeleton variant="rounded" width={30} height={24} />
      <RoundedSkeleton variant="rounded" width={70} height={14.875} />
    </Grid>
  ) : (
    <FormControlLabel
      control={<IOSSwitch isActive={value} toggleButton={handleToggle} rowId={rowId} />}
      label={value ? t('common.active') : t('common.inactive')}
      sx={{ gap: '10px' }}
      disabled={!checkPermissions(UserPermissionType.COACH_MODULE_UPDATE_COACH_STATUS)}
    />
  );
};

export default StatusSwitch;
